// プレミアム広告用
import { connect } from 'react-redux';

import { WebCategory } from '../../../../../../domain/model/category/WebCategory';
import { Page } from '../../../../common/store/interface/Page';
import { IPageDataState } from '../../store/pageData';
import { IYadsState } from '../../../../common/store/common/yads';
import { IGlobalNavigationState } from '../../store/globalNavigation';
import Component from '@/public/template/pc/common/components/js/modules/Yads';

interface Props {
  readonly page?: Page;
  readonly typeTag?: string;
}

interface IStates {
  yads?: IYadsState;
  pageData: IPageDataState;
  globalNavigation: IGlobalNavigationState;
}

// dsとparentElementはprops渡しとする
const mapStateToProps = (state: IStates, ownProps: Props) => {
  const page = ownProps.page || null;
  return {
    typeTag: ownProps.typeTag ?? getTypeTagByCategory(page, state.globalNavigation.currentCategory),
    spaYadsUpdateCount: state.yads?.spaYadsUpdateCount || 0,
    shannonId: state.pageData.yads.shannonId,
    categoryId: state.pageData.yads.categoryId
  };
};

export const getTypeTagByCategory = (page: Page | null, category?: WebCategory): string | undefined => {
  switch (page) {
    case Page.TOP:
      return getTopPageTypeTag(category);
    default:
      return undefined;
  }
};

const getTopPageTypeTag = (category?: WebCategory): string | undefined => {
  switch (category) {
    case WebCategory.MAJOR:
      return 'top_maj';
    case WebCategory.DOMESTIC:
      return 'top_dom';
    case WebCategory.WORLD:
      return 'top_wor';
    case WebCategory.BUSINESS:
      return 'top_bus';
    case WebCategory.ENTERTAINMENT:
      return 'top_ent';
    case WebCategory.SPORTS:
      return 'top_spo';
    case WebCategory.IT:
      return 'top_it';
    case WebCategory.SCIENCE:
      return 'top_sci';
    case WebCategory.LIFE:
      return 'top_lif';
    case WebCategory.LOCAL:
      return 'top_loc';
  }
  return undefined;
};

/** @deprecated 非同期タグを利用しないYadsNewPremiumに移行すること */
export default connect(mapStateToProps, {})(Component);
